import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'cmn-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  constructor(
      public elementRef: ElementRef
  ) { }

  ngOnInit() {
  }

}
